var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "d2-fork-me-on-github",
        attrs: {
          target: "blank",
          href: "https://github.com/d2-projects/d2-admin-xiya-go-cms"
        }
      },
      [
        _c("img", {
          attrs: {
            src: require("./image/darkblue@2x.png"),
            alt: "Fork me on GitHub"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }